// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsDynamodbTablesIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-dynamodb-tables_svga)" d="M40 0H0v40h40z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M26.07 31.02v-2.87c-1.53 1.31-4.7 2.17-8.54 2.17-3.85 0-7.02-.86-8.54-2.17v2.86c0 1.42 3.5 2.99 8.54 2.99 5.02 0 8.53-1.57 8.54-2.98m0-8.18h.98q0 .94-.9 1.75c.72.65.9 1.29.9 1.75v4.67c0 2.28-4.1 3.99-9.52 3.99-5.4 0-9.48-1.7-9.53-3.95v-4.72c0-.46.18-1.1.9-1.74-.71-.65-.9-1.28-.9-1.73v-4.7c0-.46.19-1.1.9-1.75-.71-.65-.9-1.28-.9-1.73v-4.7C8.02 7.7 12.1 6 17.53 6c2.6 0 5.11.43 6.87 1.18l-.38.92c-1.64-.7-4-1.1-6.5-1.1C12.5 7 9 8.57 9 10c0 1.4 3.5 2.98 8.54 2.98h.4l.04 1h-.44c-3.85 0-7.02-.86-8.54-2.17v2.88c0 .54.54 1.02.99 1.32 1.35.89 3.76 1.5 6.45 1.62l-.04 1c-2.73-.13-5.11-.71-6.65-1.6-.38.29-.75.68-.75 1.14 0 1.41 3.5 2.99 8.54 2.99q.75 0 1.45-.05l.07 1q-.74.05-1.52.05c-3.85 0-7.02-.86-8.54-2.17v2.86c0 .56.54 1.03.99 1.33 1.54 1.02 4.43 1.65 7.55 1.65h.22v1h-.22c-3.17 0-6.03-.6-7.79-1.64-.38.3-.75.7-.75 1.16 0 1.4 3.5 2.98 8.54 2.98 5.02 0 8.53-1.57 8.54-2.98 0-.46-.37-.86-.75-1.15q-.36.22-.8.4l-.39-.92q.55-.23.94-.5c.46-.3 1-.78 1-1.33m5.29-8.35h-3.29a.5.5 0 0 1-.4-.21.5.5 0 0 1-.06-.45l1.45-4.35h-6.53l-3.12 6.01h3.17q.24 0 .4.2.14.2.08.43l-2.72 10.11zm1.5-.16L19.71 28.36a.5.5 0 0 1-.84-.48l3.06-11.39H18.6a.5.5 0 0 1-.42-.24.5.5 0 0 1-.01-.5l3.64-7a.5.5 0 0 1 .43-.27h7.52q.25.01.4.2.15.22.07.46l-1.46 4.35h3.75q.31.02.45.3c.08.18.04.4-.1.54M9.73 31.04a10 10 0 0 0 2.08.87l.28-.96a9 9 0 0 1-1.87-.78zm2.08-7.23.28-.96a9 9 0 0 1-1.87-.78l-.5.87q.87.5 2.09.87m-2.08-8.97.49-.87q.75.44 1.87.78l-.28.96q-1.22-.37-2.08-.87"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="aws-dynamodb-tables_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsDynamodbTables",
);
export default AwsDynamodbTablesIcon;
